import { useEffect, useState } from 'react';
import Slider from 'react-slick/lib/slider';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

import CarouselCard from './carousel-card/carousel-card.component';

import { useCarouselStyles } from './portfolio.styles';
import { useApi } from '../../../shared/hooks/use-api.hook';
import { WorkUrls } from '../../../shared/utils/api.utils';

const settings = {
  centerMode: true,
  centerPadding: 0,
  slidesToShow: 3,
  speed: 400,
  infinite: true,
  dots: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const PortfolioCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const [getWorks, loadState, featuredWorks] = useApi({
    url: WorkUrls.getFeaturedWorks,
  });

  useEffect(() => {
    getWorks();
  }, [getWorks]);

  const classes = useCarouselStyles();

  return (
    <Slider
      {...settings}
      nextArrow={<ChevronRight sx={{ color: 'black' }} />}
      prevArrow={<ChevronLeft sx={{ color: 'black' }} />}
      beforeChange={(current, next) => setCurrentIndex(next)}
      className={classes.slider}
    >
      {featuredWorks &&
        featuredWorks.map((work, index) => (
          <CarouselCard
            key={work.id}
            active={index === currentIndex}
            work={work}
          />
        ))}
    </Slider>
  );
};

export default PortfolioCarousel;
